export default {
  SHORT: `SHORT`,
  MEDIUM: `MEDIUM`,
  LONG: `LONG`,
};
